import { useEffect } from 'react';
import { Seo } from '../components/Seo';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const Contact = () => {

  useEffect(() => {
    let isMounted = true;
    const existingScript = document.querySelector('script[src="//js.hsforms.net/forms/v2.js"]');

    const createForm = () => {
      // @ts-ignore
      if (window.hbspt && isMounted) {
        // Clear container first just in case
        const container = document.getElementById('hubspot-form-container');
        if (container) container.innerHTML = '';

        // @ts-ignore
        window.hbspt.forms.create({
          portalId: '244720409',
          formId: '66681c4f-4e0c-4538-831d-292ebe31a257',
          target: '#hubspot-form-container'
        });
      }
    };

    if (existingScript) {
      // Script already exists, just wait for it to be ready or create form immediately
      if (window.hbspt) {
        createForm();
      } else {
        existingScript.addEventListener('load', createForm);
      }
    } else {
      // Create and append script
      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', createForm);
    }

    return () => {
      isMounted = false;
      const container = document.getElementById('hubspot-form-container');
      if (container) container.innerHTML = '';

      // We don't remove the script anymore to avoid race conditions with loading,
      // and better cache utilization if the user navigates back.
      if (existingScript) {
        existingScript.removeEventListener('load', createForm);
      }
    }
  }, []);

  return (
    <>
      <Seo
        title="Contact Us - Schwabe.net"
        description="Get in touch with us."
        type="webapp"
      />
      <Header selectedNavitem="contact" />

      <div className="container py-5">
        <h1 className="text-center display-5 fw-bold mb-5">Contact Us</h1>
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div id="hubspot-form-container"></div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
};

export default Contact;